import { waitForToken } from "../loaders/waitForToken";

export const validateIsAuthenticated = async () => {
  const rolePermissions = await waitForToken("persist:root");
  const roleData = JSON.parse(rolePermissions);
  const UserDetails = JSON.parse(roleData.currentUser);
  return UserDetails?.isAuthenticated;
};
